import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { NgbActiveModal, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { StyleguideComponent } from './views/styleguide/styleguide.component';
import { TrumpipsumComponent } from './views/trumpipsum/trumpipsum.component';
import { LoginComponent } from './views/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AtlasCoreModule } from './core/core.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CommifyLabelLoaderFactory, LabelService } from './services/label.service';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { WsbFrontendComponent } from './views/wsb-frontend/wsb-frontend.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OverlayModule } from '@angular/cdk/overlay';
import { ErrorNotFoundComponent } from './views/errors/error-not-found/error-not-found.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatNativeDateModule } from '@angular/material/core';
import { SmsModule } from '@modules/sms/sms.module';
import { ColorPickerDirective } from 'ngx-color-picker';
import { PartnerDashboardComponent } from './views/partner/partner-dashboard.component';
import { RegisterComponent } from './views/register/register.component';
import { StudioComponent } from './views/studio/studio.component';
import { SubaccountManageComponent } from './views/reseller/subaccount-manage/subaccount-manage.component';
import { SubaccountDetailComponent } from './views/reseller/subaccount-detail/subaccount-detail.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ResellerHistoryComponent } from './views/reseller/reseller-history/reseller-history.component';
import { PartnerReportCampaignsComponent } from './views/partner/analytics/partner-report-campaigns.component';
import { PartnerAnalyticsComponent } from './views/partner/analytics/partner-analytics.component';
import { PartnerListReferralsComponent } from './views/partner/analytics/partner-list-referrals.component';
import { PartnerListReportReferralsComponent } from './views/partner/analytics/partner-report-referrals.component';
import { PartnerClientSetupComponent } from './views/partner/client-setup/partner-clientsetup.component';
import { HistoryDetailModalComponent } from './views/reseller/reseller-history/history-modal-detail/history-detail-modal.component';
import { EmailCampaignsListComponent } from './views/email/settings/tab-list/email-campaigns-list.component';
import { EmailCampaignsSettingsComponent } from './views/email/settings/email-campaigns-settings.component';
import { EmailCampaignDnsComponent } from './views/email/settings/tab-dns/email-campaign-dns.component';
import { ConfirmChangesComponent } from './views/account/confirm-changes/confirm-changes.component';
import { EmailCampaignSetupComponent } from './views/email/settings/tab-list/setup-list/email-campaigns-setup.component';
import { PrivacySettingModalComponent } from './views/dashboard/privacy-setting-modal/privacy-setting-modal.component';
import { LandingInfoComponent } from './views/pages/landing-stats/landing-stats/landing-info/landing-info.component';
import { LandingLinksComponent } from './views/pages/landing-stats/landing-stats/landing-links/landing-links.component';
import { LandingStatsComponent } from './views/pages/landing-stats/landing-stats/landing-stats.component';
import { LandingViewsComponent } from './views/pages/landing-stats/landing-stats/landing-views/landing-views.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { LandingDevicesComponent } from './views/pages/landing-stats/landing-stats/landing-devices/landing-devices.component';
import { EmailListComponent } from './views/email/email-list/email-history.component';
import { EmailListAllComponent } from './views/email/email-list/email-history-all/email-history-all.component';
import { EmailListSentComponent } from './views/email/email-list/email-history-sent/email-history-sent.component';
import { EmailListRunningComponent } from './views/email/email-list/email-history-running/email-history-running.component';
import { EmailListScheduledComponent } from './views/email/email-list/email-history-scheduled/email-history-scheduled.component';
import { EmailListDraftComponent } from './views/email/email-list/email-history-draft/email-history-draft.component';
import { EmailStatsComponent } from './views/email/email-list/email-stats/email-stats.component';
import { SmsadvComponent } from './views/smsadv/smsadv.component';
import { EmailCreateComponent } from './views/email/email-create/email-create.component';
import { EmailCreateSetupComponent } from './views/email/email-create/email-create-setup/email-create-setup.component';
import { EmailCreateTemplateComponent } from './views/email/email-create/email-create-template/email-create-template.component';
import { EmailCreateEditorComponent } from './views/email/email-create/email-create-editor/email-create-editor.component';
import { EmailCreateRecipientsComponent } from './views/email/email-create/email-create-recipients/email-create-recipients.component';
import { EmailCreateSummaryComponent } from './views/email/email-create/email-create-summary/email-create-summary.component';
// import Bugsnag from '@bugsnag/js';
// import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
// import { environment } from '@env';
// import { bugsnapApikey } from '@utils/constants';

// Bugsnag.start({
//   apiKey: bugsnapApikey,
//   onError(event) {
//     event.addMetadata('brand', 'name', environment.brandName);
//     if (sessionStorage.getItem('wsb-wsb-userprofile-key')) {
//       event.setUser(sessionStorage.getItem('wsb-wsb-userprofile-key'));
//     }
//   }
// });

// export function errorHandlerFactory() {
//   return new BugsnagErrorHandler();
// }

import { PartnerPaymentsComponent } from './views/partner/payments/partner-payments.component';
import { SmsAdvListComponent } from './views/smsadv/sms-adv-list/sms-adv-list.component';
import { SmsAdvListAllComponent } from './views/smsadv/sms-adv-list/sms-adv-list-all/sms-adv-list-all.component';
import { SmsAdvListSentComponent } from './views/smsadv/sms-adv-list/sms-adv-list-sent/sms-adv-list-sent.component';
import { SmsAdvListScheduledComponent } from './views/smsadv/sms-adv-list/sms-adv-list-scheduled/sms-adv-list-scheduled.component';
import { SmsAdvListDraftsComponent } from './views/smsadv/sms-adv-list/sms-adv-list-drafts/sms-adv-list-drafts.component';
import { SmsAdvCreateComponent } from './views/smsadv/sms-adv-create/sms-adv-create.component';
import { SmsAdvSelRecipientsComponent } from './views/smsadv/sms-adv-create/sms-adv-sel-recipients/sms-adv-sel-recipients.component';
import { SmsAdvCreateCampaignComponent } from './views/smsadv/sms-adv-create/sms-adv-create-campaign/sms-adv-create-campaign.component';
import { SmsAdvSummaryCampaignComponent } from './views/smsadv/sms-adv-create/sms-adv-summary-campaign/sms-adv-summary-campaign.component';
import { SelectEmailCampaignModalComponent } from './views/contacts/select-email-campaign-modal/select-email-campaign-modal.component';
import { RedirectBackFromEditorComponent } from './views/email/email-create/redirect-back-from-editor/redirect-back-from-editor.component';
import { EmailCreateTabManagerService } from '@services/email-create-tab-manager.service';
import { PartnerDiscountCodeComponent } from './views/partner/client-setup/discount-code/partner-clientsetup-discountcode.component';
import { PartnerLinkComponent } from './views/partner/client-setup/link/partner-clientsetup-link.component';
import { PartnerNewReferralComponent } from './views/partner/client-setup/new-referral/partner-clientsetup-newreferral.component';
import { ProfileManageComponent } from './views/profile/profile-manage/profile-manage.component';
import { ResellerPriceEditComponent } from './views/reseller/price-edit/reseller-price-edit.component';
import { ResellerPriceComponent } from './views/reseller/price/reseller-price.component';
import { ResellerProfileComponent } from './views/reseller/profile/reseller-profile.component';
import { ResellerProfilesComponent } from './views/reseller/profiles/reseller-profiles.component';
import { ResellerSendersComponent } from './views/reseller/senders/reseller-senders.component';
import { ResellerSubaccountHistoryComponent } from './views/reseller/subaccount-history/reseller-subaccount-history.component';
import { SuperaccountSettingsComponent } from './views/reseller/subaccount-settings/superaccount-settings.component';
import { ChangeEmailComponent } from './views/reset/change-email/change-email.component';
import { ResetPasswordComponent } from './views/reset/reset-password/reset-password.component';
import { ResetProfileComponent } from './views/reset/reset-profile/reset-profile.component';
import { CartBillingComponent } from './views/shop/cart-billing/cart-billing.component';
import { ShopCartComponent } from './views/shop/shop-cart/shop-cart.component';
import { ShopPurchaseErrorComponent } from './views/shop/shop-purchase-error/shop-purchase-error.component';
import { ShopPurchaseSuccessComponent } from './views/shop/shop-purchase-success/shop-purchase-success.component';
import { SmsSendersComponent } from './views/sms/senders/senders.component';
import { DynamicOverlay } from '@services/dynamic-overlay.service';
import { DynamicOverlayContainer } from '@services/dynamic-overlay-container.service';
import { CanDeactivateGuard } from '@services/can-deactivate-guard.service';
import { LoaderComponent } from '@ui/components/laoder/loader.component';

import { BillingDetailsComponent } from './views/billing/billing-details/billing-details.component';
import { BillingOrdersComponent } from './views/billing/billing-orders/billing-orders.component';
import { BillingSubscriptionsComponent } from './views/billing/billing-subscriptions/billing-subscriptions.component';
import { BillingPaymentMethodComponent } from './views/billing/billing-payment-method/billing-payment-method.component';
import { BillingAutoTopUpComponent } from './views/billing/billing-auto-top-up/billing-auto-top-up.component';
import { BillingComponent } from './views/billing/billing.component';
import { AppSharedModule } from './app-shared.module';

@NgModule({
  declarations: [
    AppComponent,
    StyleguideComponent,
    TrumpipsumComponent,
    LoginComponent,
    RegisterComponent,
    ProfileManageComponent,
    ErrorNotFoundComponent,
    WsbFrontendComponent,
    ShopPurchaseErrorComponent,
    ShopPurchaseSuccessComponent,
    SmsSendersComponent,
    SubaccountManageComponent,
    SubaccountDetailComponent,
    ResetPasswordComponent,
    ResetProfileComponent,
    ChangeEmailComponent,
    ResellerProfilesComponent,
    SuperaccountSettingsComponent,
    PartnerDashboardComponent,
    BillingComponent,
    StudioComponent,
    CartBillingComponent,
    ResellerProfileComponent,
    ResellerSendersComponent,
    ResellerPriceComponent,
    ResellerPriceEditComponent,
    ResellerSubaccountHistoryComponent,
    ShopCartComponent,
    ResellerHistoryComponent,
    PartnerReportCampaignsComponent,
    PartnerAnalyticsComponent,
    PartnerListReferralsComponent,
    PartnerListReportReferralsComponent,
    PartnerClientSetupComponent,
    PartnerLinkComponent,
    PartnerNewReferralComponent,
    PartnerDiscountCodeComponent,
    HistoryDetailModalComponent,
    EmailCampaignsSettingsComponent,
    EmailCampaignsListComponent,
    EmailCampaignDnsComponent,
    ConfirmChangesComponent,
    EmailCampaignSetupComponent,
    PrivacySettingModalComponent,
    LandingInfoComponent,
    LandingLinksComponent,
    LandingStatsComponent,
    LandingViewsComponent,
    LandingDevicesComponent,
    EmailListComponent,
    EmailListAllComponent,
    EmailListSentComponent,
    EmailListRunningComponent,
    EmailListScheduledComponent,
    EmailListDraftComponent,
    EmailStatsComponent,
    SmsadvComponent,
    EmailCreateComponent,
    EmailCreateSetupComponent,
    EmailCreateTemplateComponent,
    EmailCreateEditorComponent,
    EmailCreateRecipientsComponent,
    EmailCreateSummaryComponent,
    PartnerPaymentsComponent,
    SmsAdvListComponent,
    SmsAdvListAllComponent,
    SmsAdvListSentComponent,
    SmsAdvListScheduledComponent,
    SmsAdvListDraftsComponent,
    SmsAdvCreateComponent,
    SmsAdvSelRecipientsComponent,
    SmsAdvCreateCampaignComponent,
    SmsAdvSummaryCampaignComponent,
    SelectEmailCampaignModalComponent,
    RedirectBackFromEditorComponent,
    LoaderComponent,
    BillingDetailsComponent,
    BillingOrdersComponent,
    BillingSubscriptionsComponent,
    BillingPaymentMethodComponent,
    BillingAutoTopUpComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppSharedModule,
    FontAwesomeModule,
    BaseChartDirective,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: CommifyLabelLoaderFactory,
        deps: [LabelService]
      }
    }),
    InlineSVGModule.forRoot(),
    NgbModule,
    ReactiveFormsModule,
    AtlasCoreModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    }),
    BaseChartDirective,
    NgSelectModule,
    ColorPickerDirective,
    BrowserAnimationsModule,
    NgbNavModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    OverlayModule,
    FormsModule,
    CKEditorModule,
    SmsModule
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    NgbActiveModal,
    EmailCreateTabManagerService,
    DynamicOverlay,
    DynamicOverlayContainer,
    { provide: ErrorHandler },
    CanDeactivateGuard
  ],
  // entryComponents: [LoaderComponent],
  bootstrap: [AppComponent]
  // , useFactory: errorHandlerFactory
})
export class AppModule {}
